const Border: React.FC = () => <div className="h-[1px] bg-gray-1100"></div>;

export type Props = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> & {
  title: React.ReactNode;
  onClose?: () => void;
};

export const Modal: React.FC<Props> = ({
  className,
  children,
  title,
  onClose,
  ...props
}) => {
  return (
    <div
      className={`bg-black text-white rounded-lg shadow-2xl overflow-hidden ${
        className ?? ''
      }`}
      {...props}
    >
      {title && (
        <h1 className="px-6 py-4 uppercase tracking-wide font-bold bg-black rounded-t-lg">
          {title}
        </h1>
      )}
      <Border />
      <div className="p-6">{children}</div>
    </div>
  );
};
